import * as React from "react";
import { InputError } from "../InputError/InputError";
import { shortuid } from "../../utils/guid";
interface GroupedComponentsValidatorProps {
  errorMessage: string;
  errorOnTop?: boolean;
  delayErrorRender?: number;
  errorId?: string;
}

export class GroupedComponentsValidator extends React.Component<
  GroupedComponentsValidatorProps,
  {}
> {
  static defaultProps = {
    errorOnTop: false,
    delayErrorRender: 0,
  };

  private _errorId: string;

  constructor(props: GroupedComponentsValidatorProps) {
    super(props);
    this._errorId = props.errorId || shortuid();
  }

  render() {
    const { errorMessage, errorOnTop, delayErrorRender, children } = this.props;

    return (
      <div>
        {errorOnTop && errorMessage && (
          <InputError
            id={this._errorId}
            delayRender={delayErrorRender}
            errorText={errorMessage}
          />
        )}
        {children}
        {!errorOnTop && errorMessage && (
          <InputError
            id={this._errorId}
            delayRender={delayErrorRender}
            errorText={errorMessage}
          />
        )}
      </div>
    );
  }
}
